import { render, staticRenderFns } from "./IbxMenuFan.vue?vue&type=template&id=0a603f57"
import script from "./IbxMenuFan.vue?vue&type=script&lang=js"
export * from "./IbxMenuFan.vue?vue&type=script&lang=js"
import style0 from "./IbxMenuFan.vue?vue&type=style&index=0&id=0a603f57&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports